
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { FederationsStoreReducer } from './reducer';
import { FederationsStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, FederationsStoreReducer),
		EffectsModule.forFeature([FederationsStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class FederationsStoreModule { }
